var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("Acesso não permitido")]),_c('div',[_vm._v("Parece que você não possui a permissão necessária para visualizar este conteúdo")])])
}]

export { render, staticRenderFns }